import React, { useEffect, useState, useCallback, useRef } from 'react'
import { Link } from 'react-router-dom'
import { _Api } from '../../api/_call'
import { SetdataTable, UnSetdataTable } from '../../api/setdatatable'
import { Tablehead } from '../../common/modules/Tablehead'
import TableColumnModal from '../../common/modules/tableColumn'
import { VoucherList } from '../../common/graphql/commonlayouts'
import Advancedfiltermodel from '../../common/modules/advanced-filter-model'
import { stockadjustmentfreestockhead, stockadjustmentfreestockheadcheck } from '../../common/Tablehead'
import { error } from '../../common/helpers/toastify'
import { toFormatPrice } from '../../common/helpers/function'
import { useTranslation } from 'react-i18next'
import InfiniteScroll from "react-infinite-scroll-component";
import Filtermodal from '../../common/modules/Filtermodal'
import Select from "react-select"
import TableLoader from '../../../admin/common/TableLoader'
import Stockidmodal from "../../common/modules/Stockidmodal";

/* -----------------------------------------------------------------------------
 * Stock Adjustment — "Select Products For Adjustment".
 * Free-stock inventory list for building a new Stock Adjustment.
 *   list : api/v1/Inventory/stockAdjustment/freeStockList
 *          body { item, collection, metal, size, stone, productStatus,
 *                 location, price, search, limit, skip, stock_ids }
 *          response { code, success, total, data: [{ po_product_id, image,
 *                 SKU, item_name, collection_name, metal_name, stone_name,
 *                 size_name, stock_id, qty, price, price_formatted, aging,
 *                 location, location_id, status }] }
 * ---------------------------------------------------------------------------*/
const FREE_STOCK_LIST_ENDPOINT = 'api/v1/Inventory/stockAdjustment/freeStockList'

const STATUS_DOT_CLASS = {
  stock: 'light-blue-bg',
  transit: 'green-bg',
  warehouse: 'status-gray-bg',
  reserve: 'yellow-bg',
  repair_order: 'purple-bg',
  custom_order: 'danger-bg',
}

const CreateSAInventory = (props) => {
  const { t } = useTranslation()

  const dataFetched = useRef()

  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const [datalodaer, setDatsLodaer] = useState(false)
  const [limit, setLimit] = useState(100)
  const [filtername, setFiltername] = useState('')
  const [transferinventorylist, setTransferinventorylist] = useState([])
  const [createlist, setCreatelist] = useState([])
  const [selectedlocation, setSelectedlocation] = useState()
  const [SelectAllStatus, setSelectAllStatus] = useState()
  const base_url_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const [commanSelected_vouc, setcommanSelected_vouc] = useState(null)
  const [allcheck, setallCheck] = useState(false)
  const [rowlength, setRowlength] = useState(0);
  const [totalresult, setTotalresult] = useState();
  const [getSkipNumbers, setSkipNumbers] = useState(0)
  const [payload, setPayload] = useState()
  const filterbyname = (search) => {
    Gettransferinventory(currentPage, limit, payload, search)
    setstate({ ...state, currentPage: 1 })
  }
  const getlimit = (limit) => {
    setLimit(limit)
    Gettransferinventory(1, limit)
    setstate({ ...state, currentPage: 1 })
  }
  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  })

  const { currentPage } = state

  // All rows sharing one location_id means it's safe to offer "select all".
  const sameLocationAcross = (list) => {
    if (!list?.length) return false
    const firstLocationId = list[0]?.location_id
    return list.every((item) => item?.location_id === firstLocationId)
  }

  const Gettransferinventory = useCallback(
    async (current, firstlimit, filter, search, stock_id) => {
      UnSetdataTable('tbl_createSA_list')
      setDatsLodaer(true)
      try {
        var skipNumber = current ? (current - 1) * limit : 0
        const postdata = {
          item: filter?.item ? filter?.item : [],
          collection: filter?.collection ? filter?.collection : [],
          metal: filter?.metal ? filter?.metal : [],
          size: filter?.size ? filter?.size : [],
          stone: filter?.stone ? filter?.stone : [],
          productStatus: filter?.status ? filter?.status : filter?.productStatus ? filter?.productStatus : [],
          location: filter?.location ? filter?.location : [],
          price: filter?.price ? filter?.price : [],
          search: search ? search : "",
          "limit": firstlimit ? firstlimit : limit,
          skip: rowlength,
          stock_ids: stock_id?.length ? stock_id : []
        }
        let res = await _Api(
          postdata,
          FREE_STOCK_LIST_ENDPOINT,
        )
        if (res.code === 200) {
          setPayload(postdata)
          setTotalresult(res.total);
          const updatedata = (res.data || []).map(item => ({ ...item, rowclass: '' }));
          const sameLoc = sameLocationAcross(updatedata);
          setallCheck(sameLoc)
          setTransferinventorylist(updatedata)
          setDatsLodaer(false)
          setSkipNumbers(skipNumber)
          setRowlength(skipNumber);

          SetdataTable('tbl_createSA_list', '5', sameLoc ? stockadjustmentfreestockheadcheck : stockadjustmentfreestockhead
          )
          dataFetched.current = true

        } else {
          SetdataTable('tbl_createSA_list', '5', stockadjustmentfreestockhead)
        }
      } catch (err) {
        console.log(err, 'err')
      }
    },
    // eslint-disable-next-line
    [filtername, limit, state],
  )
  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 }
  ]
  const fetchMoreData = () => {
    UnSetdataTable('tbl_createSA_list')
    if (totalresult !== transferinventorylist?.length) {
      var len = rowlength + parseInt(limit);
      setDatsLodaer(true)
      setTimeout(async () => {
        try {
          const posdata = {
            item: payload?.item ? payload?.item : [],
            collection: payload?.collection ? payload?.collection : [],
            metal: payload?.metal ? payload?.metal : [],
            size: payload?.size ? payload?.size : [],
            productStatus: payload?.productStatus ? payload?.productStatus : [],
            location: payload?.location ? payload?.location : [],
            stone: payload?.stone ? payload?.stone : [],
            price: payload?.price ? payload?.price : [],
            search: filtername,
            limit: limit,
            skip: len,
          }
          let res = await _Api(posdata, FREE_STOCK_LIST_ENDPOINT);
          if (res.code === 200) {
            setRowlength(len);
            const updatedata = (res.data || []).map(item => ({ ...item, rowclass: '' }));
            const finaldata = updatedata.concat(transferinventorylist);
            const sameLoc = sameLocationAcross(finaldata);
            setallCheck(sameLoc)
            setTimeout(async () => {
              setTransferinventorylist(prevList => [...prevList, ...updatedata]);
              SetdataTable('tbl_createSA_list', '5', sameLoc ? stockadjustmentfreestockheadcheck : stockadjustmentfreestockhead)
            }, 2000);
            setDatsLodaer(false)
          }

        } catch (err) {
          console.log(err, 'err');
        }
      }, 1000);


    }
  };
  // Only one location's items can be picked in a single adjustment — dim and
  // disable rows from any other location once the first item is checked.
  const submitlist = (event) => {
    const array = [...createlist]
    const mainarray = [...transferinventorylist]
    if (event.target.checked) {
      const currentid = mainarray.filter((all) => {
        return all.po_product_id === event.target.value
      })

      if (!selectedlocation) {
        setSelectedlocation(currentid[0]?.location_id)
      }

      mainarray.forEach((result, key) => {
        if (
          result?.location_id !==
          (selectedlocation ? selectedlocation : currentid[0]?.location_id)
        ) {
          mainarray[key] = {
            ...mainarray[key],
            rowclass: 'row-inactive',
          }
        } else {
          mainarray[key] = {
            ...mainarray[key],
            rowclass: '',
          }
        }
      })
      setTransferinventorylist(mainarray)
      array.push(event.target.value)
      setCreatelist(array)
    } else {
      if (array.length === 1) {
        setCreatelist((current) =>
          current.filter((item) => item !== event.target.value),
        )
        mainarray.forEach((result, key) => {
          mainarray[key] = {
            ...mainarray[key],
            rowclass: '',
          }
          setTransferinventorylist(mainarray)
        })
        setSelectedlocation('')
      } else {
        setCreatelist((current) =>
          current.filter((item) => item !== event.target.value),
        )
      }
    }
  }
  useEffect(() => {
    if (dataFetched.current) return
    dataFetched.current = true
    Gettransferinventory()
  }, [Gettransferinventory])

  useEffect(() => {
    if (SelectAllStatus) {
      const selected = document.querySelectorAll('.createtransferinventory')
      let arrya = []
      let location_id = []
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].checked) {
          let product_id = selected[i].getAttribute('data-id')
          let location = selected[i].getAttribute('location_id')
          arrya.push(product_id)
          location_id.push(location)
        }
        setSelectedlocation(location_id[0])
      }
      setCreatelist(arrya)
    } else {
      setCreatelist([])
    }
  }, [SelectAllStatus])
  const selectedproduct = (event) => {
    if (event.target.checked) {
      const mainselected = [...createlist, event.target.value]
      setCreatelist(mainselected)
    } else {
      const result = createlist.filter((element) => {
        return element !== event.target.value
      })
      setCreatelist(result)
    }
  }
  const countstockid = (stiockidindex) => {
    if (stiockidindex) {
      const numbersArray = stiockidindex.split(/\D+/)
      if (numbersArray?.length) {
        Gettransferinventory(currentPage, 'ALL', payload, filtername, numbersArray)
      } else {
        error("Somthing Went Wrong");
      }
    } else {
      Gettransferinventory(currentPage, limit, payload, filtername, [])
    }
  };
  return (
    <React.Fragment>
      <div className="main-body">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">

              <div className="top-heading-area">
                <div className="top-heading-area-left">
                  <Link
                    to="/app/inventory/stockAdjustment"
                    className="page-back-btn"
                  >
                    <img
                      src={base_url_assets + 'images/icons/arrow-left.png'}
                      alt=""
                    />
                  </Link>
                  <img
                    src={base_url_assets + 'images/icons/home-icon.png'}
                    alt=""
                  />
                  <VoucherList
                    setcommanSelected_vouc={setcommanSelected_vouc}
                    group={'Stock_Adjustment'}
                  ></VoucherList>
                </div>
                <h1 className="main-heading text-center">
                  {t('Select Products For Adjustment')}
                </h1>
              </div>
              <div className="main-body-top-tab-bar create-purchase-top-bar">
                <div className="main-body-top-tab-bar-left-col nav nav-pills">
                  <Link className="main-body-top-tab-bar-left-col-a nav-link active table-refresh">
                    <span className="main-body-top-tab-bar-left-col-a-text">
                      <img
                        src={
                          base_url_assets + 'images/icons/inventory-icon.png'
                        }
                        alt=""
                      />
                      {t('Inventory List')}
                    </span>
                  </Link>
                </div>
              </div>
              <div className="main-body-top-status-bar justify-content-between">
                <div className='d-flex'>
                  <Select
                    className="limit-select short mx-3 z-10"
                    options={selectOptions}
                    value={{ label: limit, value: limit }}
                    onChange={(e) => {
                      setLimit(e.value)
                      getlimit(e.value)
                      setRowlength(0)
                    }}
                  />
                  <div className="main-body-top-status-bar-filter">
                    <button
                      className="main-body-top-status-bar-filter-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#filterinventory"
                    >
                      <img
                        className="d-block"
                        src={base_url_assets + '/images/icons/search-outline.png'}
                        alt=""
                      />
                    </button>
                    <input
                      type="text"
                      value={filtername}
                      className="main-body-top-status-bar-filter-input"
                      placeholder={t('StockID/SKU')}
                      onKeyPress={(e) => e.key === 'Enter' && filterbyname(e.target.value)}
                      onChange={(e) => setFiltername(e.target.value)}
                    />
                    {filtername ? (
                      <img
                        className="main-body-top-status-bar-filter-clear"
                        src={base_assets + 'images/icons/False.png'}
                        onClick={(e) => { setFiltername(''); filterbyname(e.target.value) }}
                        alt=""
                      />
                    ) : (
                      ''
                    )}
                    <button
                      onClick={() => filterbyname(filtername)}
                      className="main-body-top-status-bar-filter-search"
                    >
                      <i className="fa fa-search" aria-hidden="true" />
                    </button>
                  </div>
                </div>
                <div className='d-flex gap-3'>
                  <button className="print-export-dropdown-selected-icon ms-auto"
                    data-bs-toggle="modal"
                    data-bs-target="#Stockidmodal">
                    <img
                      className={"deletebtn d-block"}
                      src={base_assets + "images/icons/clone.svg"}
                      alt=""
                    />
                  </button>
                  {createlist?.length ? (
                    <Link
                      className="ms-auto com-btn"
                      to="/app/inventory/createStockAdjustment"
                      state={{
                        createlist: createlist,
                        Voucher_id: commanSelected_vouc,
                        hidelocationid: selectedlocation,
                        myinventory: false
                      }}
                    >
                      {t('Submit')}
                    </Link>
                  ) : (
                    <button
                      className="ms-auto com-btn"
                      onClick={() => error(t('No item Selected!!'))}
                    >
                      {t('Submit')}
                    </button>
                  )}
                </div>
              </div>
              <div className="common-sub-table-wrap add-row">
                <div className="main-body-main-table-wrap">
                  <InfiniteScroll
                    dataLength={transferinventorylist ? transferinventorylist?.length : 0}
                    next={() => totalresult > rowlength ? fetchMoreData() : ""}
                    hasMore={totalresult > transferinventorylist.length ? true : false}
                    loader={
                      totalresult > transferinventorylist.length ? (
                        <h6>{t('Loading more Data...')}</h6>
                      ) : null
                    }
                  >
                    <table
                      id="tbl_createSA_list"
                      className="common-table first-row-gray w-100"

                    >

                      <Tablehead
                        tablehead={allcheck ? stockadjustmentfreestockheadcheck : stockadjustmentfreestockhead}
                        tblName={'tbl_inventory_stockadjustment_freestock'}
                        setfilterby={''}
                        setShowoption={setSelectAllStatus}
                      />
                      <tbody id="allsamedata">
                        {transferinventorylist?.length
                          ? transferinventorylist.map((result, key) => {
                            return (
                              <tr
                                id={`common-main-table-wrap-${result?.po_product_id}`}
                                className={
                                  result?.rowclass ? result?.rowclass : ''
                                }
                                key={key}
                              >
                                <td >
                                  <div className={
                                    result?.rowclass === 'row-inactive'
                                      ? 'com-check checkbox-disabled'
                                      : 'com-check'
                                  }>
                                    <input
                                      id={result?.po_product_id}
                                      data-id={result?.po_product_id}
                                      value={result?.po_product_id}
                                      location_id={result?.location_id}
                                      className={"createtransferinventory createtransferinventoryhead"}
                                      onChange={selectedproduct}
                                      onClick={submitlist}
                                      disabled={result?.rowclass === 'row-inactive'}
                                      type="checkbox"
                                    />
                                    <label htmlFor={result?.po_product_id} className="com-check-label" />
                                  </div>
                                </td>
                                <td>{parseInt(key + getSkipNumbers + 1)}</td>
                                <td className="table-pro-img">
                                  <img
                                    src={
                                      result?.image
                                        ? result?.image
                                        : "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png"
                                    }
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
                                    }}
                                    alt=""
                                  />
                                </td>
                                <td className="po-no">
                                  {result?.SKU ? result?.SKU : ''}
                                </td>
                                <td>
                                  {result?.item_name ? result?.item_name : ''}
                                </td>
                                <td>
                                  {result?.collection_name
                                    ? result?.collection_name
                                    : ''}
                                </td>
                                <td>
                                  {result?.metal_name ? result?.metal_name : ''}
                                </td>
                                <td>
                                  {result?.stone_name ? result?.stone_name : ''}
                                </td>
                                <td>
                                  {result?.size_name ? result?.size_name : ''}
                                </td>
                                <td>{result?.stock_id ? result?.stock_id : ''}</td>
                                <td>{result?.qty ? result?.qty : '0'}</td>
                                <td>
                                  {result?.price_formatted
                                    ? result?.price_formatted
                                    : toFormatPrice(result?.price, { addSymbol: true })}
                                </td>
                                <td className="text-end">
                                  {result?.aging ? result?.aging : '0'}
                                </td>
                                <td className="location-td">
                                  <span className="link-color">
                                    {result?.location ? result?.location : ''}
                                  </span>
                                </td>
                                <td>
                                  <div
                                    className={
                                      "status-dot tooltip-area-up " +
                                      (STATUS_DOT_CLASS[result?.status] || 'status-gray-bg')
                                    }
                                  >
                                    <span className="tooltip-area-up-text">
                                      {result?.status
                                        ? t(result.status.charAt(0).toUpperCase() + result.status.slice(1))
                                        : ''}
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            )
                          })
                          : ''}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td>
                            {transferinventorylist
                              ? transferinventorylist?.reduce(
                                (interation, val) =>
                                (interation =
                                  interation + (parseInt(val.qty, 10) || 0)),
                                0,
                              )
                              : ''}
                          </td>
                          <td>
                            {
                              toFormatPrice(transferinventorylist
                                ? transferinventorylist?.reduce(
                                  (interation, val) =>
                                  (interation =
                                    interation + (Number(val?.price) || 0)),
                                  0
                                )
                                : "", { addSymbol: true })
                            }
                            {' '}
                          </td>
                          <td />
                          <td />
                          <td />
                        </tr>
                      </tfoot>
                    </table>
                    {datalodaer && <TableLoader />}

                  </InfiniteScroll>
                </div>
              </div>
            </div>
            <Filtermodal submitfiltter={Gettransferinventory} limit={limit} custom_filter_enable={true} />
          </div>
        </div>
      </div>
      <Stockidmodal
        countstockid={countstockid}
      />
      <TableColumnModal
        tablehead={allcheck ? stockadjustmentfreestockheadcheck : stockadjustmentfreestockhead}
        tblName={'tbl_inventory_stockadjustment_freestock'}
        calldatatable={Gettransferinventory}
      ></TableColumnModal>
      <Advancedfiltermodel></Advancedfiltermodel>
    </React.Fragment >
  )
}

export default CreateSAInventory
